import {
  POST_CERT_BANNERS,
  POST_CERTIFICATE_LIST,
  POST_CERTIFICATE_QUERY,
  POST_CERTIFICATE_CHECKINVITE_CODE,
  POST_CERTIFICATE_TOREGISTER,
  POST_CERTIFICATE_TOEXAM,
  POST_CERTIFICATE_INFO,
  POST_CERTIFICATE_UPDATE_EXAM,
  POST_CERTIFICATE_CHECK_PAY_MENT,
  POST_BASE_ISPLIST,
  POST_LOGIN_ISP,
  POST_CERTIFICATE_HOME_LIST,
  POST_TOREGISTER,
  POST_CERT_V2_BANNERS
} from "@/api/apiConst/certification";
import request from "@/api/http/request";

export interface certBannerType {
  image: string;
  jumpUrl: string;
  mobileImage?: string;
  imagePlayVideo?: {
    vid: string;
    kid: string;
    mainUrl: string;
  };
}
// 认证banner
export function getCertBanners() {
  return request.post<certBannerType[]>(POST_CERT_BANNERS);
}
// 认证banner v2
export function getCertV2Banners() {
  return request.post<certBannerType[]>(POST_CERT_V2_BANNERS);
}

export interface certInfoList {
  businessId: string;
  courseId?: string;
  coverImg: string;
  detailImg: string;
  introduce: string;
  isEntry?: number;
  title: string;
  codeStatus?: number;
  /** 考试状态 */
  entryStatus?: number;
  entryStatusRef?: string;
  /** 课程学习状态 */
  courseLearningStatus?: number;
  courseLearningStatusRef?: string;
}
// 认证信息列表
export function getCertList() {
  return request.post<certInfoList[]>(POST_CERTIFICATE_LIST);
}

// 首页认证列表
export function getCertHomeList() {
  return request.post<{
    certificateTagRef: string;
    firstLevel: Array<{ businessId: string; title: string }>;
    sencondLevel?: Array<{ businessId: string; title: string }>;
    secondLevel?: Array<{ courseId: string; title: string }>;
  }[]>(POST_CERTIFICATE_HOME_LIST);
}
export type certInfoStr =
  | "certificateCode"
  | "certificateImg"
  | "certificateTitle"
  | "expirationDate"
  | "studentEmail"
  | "studentIdcard"
  | "studentName"
  | "studentTel"
  | "status";
export interface certQueryInfoType {
  /** 证书编号 */
  certificateCode: string;
  /** 证书封面 */
  certificateImg: string;
  /** 证书名称 */
  certificateTitle: string;
  /** 有效期 */
  expirationDate: string;
  /** 邮箱 */
  studentEmail: string;
  /** 身份证 */
  studentIdcard: string;
  /** 学员名称 */
  studentName: string;
  /** 手机号 */
  studentTel: string;
  status: 0 | 1;
}
// 认证证书查询
export function getCertQuery(data: { number: string; name: string }) {
  return request.post<certQueryInfoType>(POST_CERTIFICATE_QUERY, data);
}

// 校验认证邀请码
export function getCertCheckInviteCode(data: {
  courseId: string;
  inviteCode?: string;
  certId: string;
  type: 1 | 2;
}) {
  return request.post(POST_CERTIFICATE_CHECKINVITE_CODE, data);
}
// 跳转考试星支付
export function getCertCheckPayMent(data: {
  courseId: string;
  certId: string;
}) {
  return request.post(POST_CERTIFICATE_CHECK_PAY_MENT, data);
}

// 认证注册报名
export function getCertToRegister(data: {
  certId: string;
  /** 1邀请码 2个人支付 */
  writeOffType: 1 | 2;
}) {
  return request.post<string>(POST_CERTIFICATE_TOREGISTER, data);
}

// 修改考试信息
export function getCertUpdateExam(data: { certId: string }) {
  return request.post<string>(POST_CERTIFICATE_UPDATE_EXAM, data);
}
// 认证注册考试
export function getCertToExam(data: { certId: string }) {
  return request.post<string>(POST_CERTIFICATE_TOEXAM, data);
}
export interface certInfoType {
  businessId: string;
  /** 证书是否可报名 0否 1是 */
  isStart: 0 | 1;
  amount: number;
  discountAmount?: number;
  discountDeadlineFmt?: string;
  /** 0邀请码 1付费 2全部 */
  entryType: 0 | 1 | 2;
  title?: string;
  abilityAssessExamId?: string;
  exercisesExamId?: string;
  /** 0不弹福利课程框 1弹 */
  benefitCourseFlag?: '0' | '1';
  /** 福利课程id */
  benefitCourseId?: string;
}
// 认证证书信息
export function getCertInfo(data: { id: string }) {
  return request.post<certInfoType>(POST_CERTIFICATE_INFO, data);
}
export interface ispListType {
  businessId: string;
  label: string;
}
export function getIspList() {
  return request.post<ispListType[]>(POST_BASE_ISPLIST);
}
export function getLoginIsp(data: {
  name: string;
  email: string;
  spName: string;
}) {
  return request.post<{token:string}>(POST_LOGIN_ISP, data);
}


export function staffToRegister(data: { "certId": string }) {
  return request.post(POST_TOREGISTER,data);
}
